import moment from 'moment';
import get from 'lodash/get';

export default function checkDataAvailable (date, data = {}) {
  const strictDate =  moment(date, "YYYY-MM-DD").format("MM/DD/YYYY");
  const isSpotAvailable = get(data, [strictDate, "Pre-Recorded"], false);
  const isLiveReadAvailable = get(data, [strictDate, "Live Reads"], false);
  const isWatchlistAvailable = get(data, [strictDate, "Watchlist"], false);
  return {
    isSpotAvailable,
    isLiveReadAvailable,
    isWatchlistAvailable
  }
}